// extracted by mini-css-extract-plugin
export default {"streamCard":"LiveStreams_streamCard__TcDHU","embedWrapper":"LiveStreams_embedWrapper__f0mgf"};